var map = {
	"./1.png": 5100,
	"./2.png": 5159,
	"./3.png": 6846,
	"./3a.png": 7349,
	"./4.png": 7857,
	"./5.png": 9992,
	"./5a.png": 5155,
	"./6.png": 5267,
	"./7.png": 7690,
	"./8.png": 7549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6772;